// Progress bar specifically for the active focus task.
import { Box } from '@mui/material';
import useCurrentTime from '@/features/tasks/hooks/status/use-task-current-time.js';
import { getFocusTimerColor } from '@/features/tasks/utils/ui/focusTimerUtils.js';
import { MS_PER_MINUTE } from '@/config/constants';

const PERCENT_BASE = 100;

export const FocusTaskProgress = ({ focusStartTime, duration }) => {
  const currentTime = useCurrentTime();

  if (!focusStartTime || !duration) return null;

  const elapsedMs = currentTime.getTime() - focusStartTime;
  const elapsedMinutes = Math.max(0, Math.floor(elapsedMs / MS_PER_MINUTE));
  const percentage = Math.min(
    PERCENT_BASE,
    (elapsedMinutes / duration) * PERCENT_BASE,
  );
  const bgColor = getFocusTimerColor(elapsedMinutes, duration, {
    includeWarning: true,
  });

  return (
    <Box
      data-testid="focus-task-progress"
      sx={{
        width: '100%',
        height: '6px',
        bgcolor: 'var(--color-grey-200)',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: `${percentage}%`,
          bgcolor: bgColor,
          transition: 'width 1s linear, background-color 0.3s ease',
        }}
      />
    </Box>
  );
};
